import { Skeleton } from '@/_components';

export function InvoiceDetailsLoading() {
  return (
    <div className="space-y-2 px-2 py-2">
      <Skeleton className="h-5 w-1/2" />
      <Skeleton className="h-8 w-full" />
      <Skeleton className="h-8 w-full" />
      <Skeleton className="h-24 w-full" />
    </div>
  );
}
